export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.27-1333.07',
  commitId: 'a5020ec384582199a14fddee9a2c53a76b26e178',
  commitTime: '2026-03-27T13:33:07.000Z',
});
